<template>
  <Component :is="continuous ? 'div' : BaseCard" :class="containerClasses">
    <p id="candidateEducation" class="mb-8 w-32 bg-gradient-to-r bg-clip-text font-bold text-transparent from-bdBlue-600 to-bdPurple-600">
      Education.
    </p>
    <EditableFormDetailedList name="Education Entry"
                              :allows="candidateEducationBadges.education.allows"
                              :list="candidate.education" :icon="AcademicCapIcon" :small="small"
                              :editable="editable" @update:list="updateCandidate('education', $event)"/>
    <p v-if="!editable && !candidate.education?.length" class="-mt-2 mb-4 text-sm text-slate-400">
      No education entered yet
    </p>
    <div v-if="showCertificates" class="mb-4 flex flex-wrap items-start justify-start gap-4">
      <CandidateCertificatePreview v-for="(cert, index) in certificates" :key="index" :certificate="cert"
                                   @update:certificate="updateCertificate(index, $event)"
                                   @delete="deleteCertificate(index)" :editable="editable"/>
    </div>
    <FormButton v-if="editable" color="gradient" @click="addCertificate" class="block mx-auto max-w-fit mt-4 mb-2">
      Add Certificate
    </FormButton>
  </Component>
</template>

<script setup>
import BaseCard from "./BaseCard.vue";
import CandidateCertificatePreview from "./CandidateCertificatePreview.vue";
import EditableFormDetailedList from "./EditableFormDetailedList.vue";
import FormButton from "./FormButton.vue";
import {AcademicCapIcon} from "@heroicons/vue/24/outline/index.js";
import {computed} from "vue";
import {candidateEducationBadges} from "../helpers/ProfileQuestions.js";

const emits = defineEmits(["update:candidate"]);
const props = defineProps({
  candidate: Object,
  continuous: Boolean,
  small: Boolean,
  editable: Boolean,
});

const updateCandidate = (field, value) => {
  if (!props.editable) return;

  const c = {...props.candidate};
  c[field] = value;
  emits("update:candidate", c);
};

const addCertificate = () => {
  if (!props.editable) return;

  let certificates = props.candidate.certificatesCertificationsAndLicenses;
  if (!certificates) certificates = [];

  certificates.push({
    title: "",
    path: "",
  });

  updateCandidate("certificatesCertificationsAndLicenses", certificates);
};

const updateCertificate = (index, value) => {
  if (!props.editable) return;

  let certificates = props.candidate.certificatesCertificationsAndLicenses;
  if (!certificates) certificates = [];

  while (certificates.length <= index) {
    certificates.push({
      title: "",
      path: "",
    });
  }

  certificates[index] = value;

  updateCandidate("certificatesCertificationsAndLicenses", certificates);
};

const deleteCertificate = (index) => {
  if (!props.editable) return;

  let certificates = props.candidate.certificatesCertificationsAndLicenses;
  if (!certificates) certificates = [];

  certificates.splice(index, 1);

  updateCandidate("certificatesCertificationsAndLicenses", certificates);
};

const containerClasses = computed(() => {
  const baseClasses = props.continuous ? "px-4 md:px-6 mt-6" : "relative shadow-sm mt-6";
  return baseClasses + (props.small ? " text-sm" : " text-base");
});

const showCertificates = computed(() => {
  if (props.editable) return true;
  return props.candidate?.certificatesCertificationsAndLicenses && props.candidate.certificatesCertificationsAndLicenses.length;
});

const certificates = computed(() => {
  return props.candidate.certificatesCertificationsAndLicenses;
});
</script>
